import React from "react";
import styles from "./fix-pager-group.module.scss";
import { FixPager } from "../fix-pager";
import { FixPagerMessage } from "../fix-pager-message";
import { LayoutStyleTypes } from "@/util-react/layout";

export interface FixPagerGroupProps {
  type: LayoutStyleTypes.TYPE_SM | LayoutStyleTypes.TYPE_LG;
  total: number;
  current: number;
  totalItems: number;
  size: number;
  next?: boolean;
  pager?: boolean;
  onNext?: () => void;
  currentUrl?: string;
  onChange?: (page: number) => void;
}

export const FixPagerGroup: React.FC<FixPagerGroupProps> = ({
  type,
  total,
  current,
  totalItems,
  size,
  pager = false,
  currentUrl,
  onChange = () => {},
}) => (
  <div className={`${styles.container} ${styles.centred} ${styles[type]}`}>
    {pager && (
      <div className={`${styles.padding} ${styles.centred}`}>
        <FixPagerMessage className={styles.message} current={current} totalItems={totalItems} size={size} />
        <FixPager className={styles.pager} current={current} total={total} onChange={onChange} currentUrl={currentUrl} />
      </div>
    )}
  </div>
);

export default FixPagerGroup;
